import { Trans, useTranslation } from 'react-i18next';
import { Card } from '@/components/StackCards/types';
import { NumericRange } from '@/types/range';
import { mergeClasses } from '@/utils/style';
import { Button } from '@/components/buttons';
import React from 'react';
import { SectionHeadline } from '@/components/SectionHeadline';
import { StackCards } from '@/components/StackCards';
import { Link } from '@/components/links';
import { LINKS } from '@/constants/links';

export function HowItWorks() {
	const { t } = useTranslation(['career']);

	const cards: Card[] = Array.from({ length: 5 }, (_, index) => {
		const cardIndex = (index + 1) as NumericRange<1, 5>;
		return {
			index,
			title: (
				<div className={mergeClasses(cardIndex === 4 && 'text-center lg:text-left')}>
					{t(`howItWorks.items.${cardIndex}.title`)}
				</div>
			),
			...(cardIndex < 5
				? {
						description: (
							<Trans t={t} i18nKey={`howItWorks.items.${cardIndex}.text`}>
								<Link
									to={`${LINKS().careerList}#contact`}
									testId="careerContact"
									analyticsParam="careerContact"
								/>
							</Trans>
						),
					}
				: {
						footer: (
							<Button
								analyticsParam="careerCareerList"
								testId="careerCareerList"
								variant="primary"
								size="lg"
								className="m-auto w-full md:w-auto lg:m-0"
								to={LINKS().careerList}
							>
								{t(`howItWorks.items.${cardIndex}.text`)}
							</Button>
						),
					}),
			images: {
				desktop: {
					src: `/images/sections/career/cards/cs/${cardIndex}.png`,
					alt: t(`howItWorks.items.${cardIndex}.title`),
				},
				mobile: {
					src: `/images/sections/career/cards/cs/${cardIndex}.png`,
					alt: t(`howItWorks.items.${cardIndex}.title`),
				},
			},
		};
	});

	return (
		<>
			<SectionHeadline
				className="mb-12 px-4 md:mb-16"
				variant="inverted"
				anchorKey="howItWorks.title"
			>
				{t('howItWorks.title')}
			</SectionHeadline>
			<StackCards imagePosition="left" cards={cards} />
		</>
	);
}
